import { Link } from 'react-router-dom'
import { Badge } from '@/components/ui/badge'
import { categoryColor, SOURCE_LABEL } from './categoryStyle'
import type { Concept } from '../api/knowledgeApi'

export function CategoryBadge({ category }: { category: string | null }) {
  const color = categoryColor(category)
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs"
      style={{ borderColor: `${color}55`, color }}
    >
      <span className="h-2 w-2 rounded-full" style={{ background: color }} />
      {category ?? 'uncategorised'}
    </span>
  )
}

export function SourceBadges({ sources }: { sources: string[] }) {
  return (
    <span className="inline-flex flex-wrap gap-1">
      {sources.map((s) => (
        <Badge key={s} variant={s === 'legacy_2024' ? 'secondary' : 'outline'} className="text-[10px] font-normal">
          {SOURCE_LABEL[s] ?? s}
        </Badge>
      ))}
    </span>
  )
}

/** A concept as a clickable chip: name, category colour, and how many artworks carry it. */
export function ConceptChip({ concept, extra }: { concept: Pick<Concept, 'ucid' | 'name' | 'category' | 'artworkCount'>; extra?: string }) {
  const color = categoryColor(concept.category)
  return (
    <Link
      to={`/app/knowledge/${concept.ucid}`}
      className="inline-flex items-center gap-1.5 rounded-full border bg-white px-2.5 py-1 text-xs hover:bg-slate-50"
      title={concept.category ?? undefined}
    >
      <span className="h-2 w-2 shrink-0 rounded-full" style={{ background: color }} />
      <span className="max-w-[16rem] truncate">{concept.name}</span>
      <span className="tabular-nums text-slate-400">{extra ?? concept.artworkCount}</span>
    </Link>
  )
}
